export default {
  'llm.callLogs.source': 'Execution source',
  'llm.callLogs.officialSource': 'Official services',
  'llm.callLogs.tenantSource': 'Tenant models',
  'llm.callLogs.localSource': 'Other local services',
  'llm.callLogs.syncPending':
    'Official synchronization is pending or unavailable. Showing saved records.',
  'llm.callLogs.lastSynced': 'Official data last synchronized',
  'llm.callLogs.officialUnavailable':
    'Official request and response bodies are temporarily unavailable. Retry later.',
  'llm.callLogs.app': 'Application',
  'llm.callLogs.scene': 'Scene',
  'llm.callLogs.caller': 'Caller',
  'llm.callLogs.resource': 'Resource ID',
  'llm.callLogs.running': 'Running',
  'llm.callLogs.cancelled': 'Cancelled',
  'llm.callLogs.unknown': 'Outcome unknown',
  'llm.callLogs.notProvided': 'Not provided',
  'llm.callLogs.estimated': 'Estimated',
  'llm.callLogs.serviceType': 'Service type',
  'llm.callLogs.actions': 'Actions',
  'llm.callLogs.details': 'Call details',
  'llm.callLogs.viewDetails': 'View details',
  'llm.callLogs.detailFailed': 'Failed to load details',
  'llm.callLogs.complete': 'Complete',
  'llm.callLogs.truncated': 'Truncated',
  'llm.callLogs.notCaptured': 'Not captured',
  'llm.callLogs.expired': 'Expired',
  'llm.callLogs.expiredBody': 'Body exceeded the 30-day retention period',
  'llm.callLogs.retry': 'Retry',
  'llm.callLogs.incomplete':
    'Call did not finish completely; showing captured content',
  'llm.callLogs.status': 'Status',
  'llm.callLogs.entryPoint': 'Entry point',
  'llm.callLogs.startedAt': 'Started at',
  'llm.callLogs.endedAt': 'Ended at',
  'llm.callLogs.duration': 'Total duration',
  'llm.callLogs.firstResponse': 'Time to first response',
  'llm.callLogs.upstreamId': 'Upstream Request ID',
  'llm.callLogs.streaming': 'Streaming',
  'llm.callLogs.yes': 'Yes',
  'llm.callLogs.no': 'No',
  'llm.callLogs.requestBody': 'Request body',
  'llm.callLogs.responseBody': 'Response body',
  'llm.callLogs.usage': 'Usage and cost',
  'llm.callLogs.inputTokens': 'Input tokens',
  'llm.callLogs.outputTokens': 'Output tokens',
  'llm.callLogs.totalTokens': 'Total tokens',
  'llm.callLogs.cacheReadTokens': 'Cache read tokens',
  'llm.callLogs.cacheWriteTokens': 'Cache write tokens',
  'llm.callLogs.cacheWrite1hTokens': '1-hour cache write tokens',
  'llm.callLogs.reasoningTokens': 'Reasoning tokens',
  'llm.callLogs.usageSource': 'Usage source',
  'llm.callLogs.meter': 'Metering',
  'llm.callLogs.cost': 'Cost',
  'llm.callLogs.settlement': 'Settlement amount',
  'llm.callLogs.errorsAndAttempts': 'Errors and attempts',
  'llm.callLogs.errorCode': 'Error code',
  'llm.callLogs.failedStage': 'Failure stage',
  'llm.callLogs.errorMessage': 'Error message',
  'llm.callLogs.related': 'Related calls',
  'llm.callLogs.modelService': 'Model',
  'llm.callLogs.digitalHuman': 'Digital human',
  'llm.callLogs.loadFailed': 'Failed to load call logs. Please retry.',
  'llm.callLogs.requestIdHint':
    'Enter the complete Request ID for an exact match',
  'llm.callLogs.scope': 'Scope',
  'llm.callLogs.modelCode': 'Enter model code',
  'llm.callLogs.sceneCode': 'Enter scene code',
  'llm.callLogs.reset': 'Reset',
  'llm.callLogs.search': 'Search',
  'llm.callLogs.collapse': 'Collapse advanced search',
  'llm.callLogs.advanced': 'Advanced search',
  'llm.callLogs.retentionHint':
    'Searches all retained logs by default. All conditions must match.',
  'pages.navigation.items.modelCallLogs': 'Platform call logs',
  'llm.callLogs.officialLogs': 'Platform call logs',
  'llm.callLogs.tenant': 'Tenant',
  'llm.callLogs.refresh': 'Refresh',
  'pages.navigation.items.aiScenes': 'Application Scenes',
  'pages.navigation.items.modelPolicies': 'Runtime policies',
  'pages.navigation.items.modelCircuits': 'Circuit breakers',

  'menu.centers.aiModels': 'AI Models',
  'pages.navigation.items.modelAccess': 'Model Access',
  'pages.navigation.items.modelUsage': 'Platform Usage',
  'pages.navigation.items.modelTenantUsage': 'Tenant Usage Management',

  'menu.centers.workspace': 'Home',
  'menu.centers.applications': 'Applications',
  'menu.centers.capabilities': 'Services',
  'menu.centers.markets': 'Marketplace',
  'menu.centers.resources': 'Operations',
  'menu.centers.commercial': 'Sales',
  'menu.centers.management': 'Tenants',
  'menu.centers.settings': 'Settings',
  'menu.centers.resourceOverview': 'Resource overview',
  'pages.navigation.mainNavigation': 'Main navigation',
  'pages.navigation.skipToContent': 'Skip to main content',
  'pages.navigation.resizeSidebar': 'Resize sidebar',
  'pages.navigation.items.appMarket': 'App Market',
  'pages.navigation.items.skillMarketplace': 'Skill Market',
  'pages.navigation.items.mcpMarketplace': 'MCP Market',
  'pages.navigation.items.pluginMarketplace': 'Plugin Market',
  'pages.navigation.items.workspaceOverview': 'Workspace overview',
  'pages.navigation.items.agentApps': 'Agent management',
  'pages.navigation.items.models': 'Model Hub',
  'pages.navigation.items.events': 'Event engine',
  'pages.navigation.items.mcp': 'MCP services',
  'pages.navigation.items.resourceOverview': 'Resource overview',
  'pages.navigation.items.clusters': 'Clusters',
  'pages.navigation.items.storage': 'Application storage',
  'pages.navigation.items.knowledge': 'Knowledge bases',
  'pages.navigation.items.dataSources': 'Data sources',
  'pages.navigation.items.applicationManagement': 'Application management',
  'pages.navigation.items.applications': 'Business applications',
  'pages.navigation.items.pluginApplications': 'Plugin applications',
  'pages.navigation.items.applicationFeedback': 'App feedback',
  'pages.navigation.items.externalPublication': 'External app listing',
  'pages.navigation.items.publicationReview': 'App listing review',
  'pages.navigation.items.taxonomies': 'Taxonomies',
  'pages.navigation.items.aiServices': 'AI Services',
  'pages.navigation.items.digitalHumanMarket': 'Digital Humans',
  'pages.navigation.items.digitalHumanMarketplace': 'Digital Human Market',
  'pages.navigation.items.mcpMarket': 'MCP',
  'pages.navigation.items.skillMarket': 'Skills',
  'pages.navigation.items.products': 'Product catalog',
  'pages.navigation.items.packages': 'Packages',
  'pages.navigation.items.entitlements': 'Tenant entitlements',
  'pages.navigation.items.platformTenants': 'Tenant Management',
  'pages.navigation.items.platformUsers': 'User Management',
  'pages.navigation.items.platformPermissions': 'Platform Permissions',
  'pages.navigation.items.platformSettings': 'Platform Settings',
  'pages.navigation.items.orders': 'Payment orders',
  'pages.navigation.items.members': 'Members',
  'pages.navigation.items.departments': 'Departments',
  'pages.navigation.items.roles': 'Permissions',
  'pages.navigation.items.auditLog': 'Audit log',
  'menu.centers.appStore': 'Deployment Templates',
  'menu.centers.deployments': 'My deployments',
  'pages.navigation.items.appStore': 'Deployment Templates',
  'pages.navigation.items.deployments': 'My deployments',
  'menu.centers.images': 'Image registry',
  'pages.navigation.items.images': 'Image registry',
};
